import { observer } from 'mobx-react-lite';

import { FormNumberInput } from 'src/shared/components/form-components';

import type { IntegerField } from '../../../../shared/entities/control-entities';

type Props = {
  className?: string;
  label?: string;
  item: IntegerField;
  isDisabled: boolean;
  onBlur?: VoidFunction;
  onChange(value: number | null): void;
};

export const NewWellIntegerField = observer(function NewWellIntegerField({
  className,
  label,
  item,
  isDisabled,
  onBlur,
  onChange,
}: Props) {
  const localOnChange = (value: number | null): void => {
    onChange(value);
  };

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FormNumberInput
      value={item.value}
      isInteger
      label={label}
      className={className}
      isError={!!item.errorText}
      errorText={item.errorText}
      placeholder={item.placeholder}
      unit={item.unit}
      isDisabled={isDisabled}
      onChange={localOnChange}
      onFocus={item.clearError}
      onBlur={handleBlur}
    />
  );
});
